
export const MessagesStatusesEnum = {
  sent: 'Sent',
  sent_index: 0,
  read: 'Read',
  read_index: 1,
  error: 'Error',
  undelivered: 'Undelivered',
  undelivered_index: 3,
} as const;

export const MessagesStatuses = [
  { index: 0, status: MessagesStatusesEnum.sent },
  { index: 1, status: MessagesStatusesEnum.read },
  { index: 2, status: MessagesStatusesEnum.error },
  { index: 3, status: MessagesStatusesEnum.undelivered },
]

export const axiosResponseCodesEnum = {
  err_network: 'ERR_NETWORK',
} as const;
